import { render, staticRenderFns } from "./DamagedProductsReport.vue?vue&type=template&id=53000ea8&scoped=true"
import script from "./DamagedProductsReport.vue?vue&type=script&lang=js"
export * from "./DamagedProductsReport.vue?vue&type=script&lang=js"
import style0 from "./DamagedProductsReport.vue?vue&type=style&index=0&id=53000ea8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53000ea8",
  null
  
)

export default component.exports